// extracted by mini-css-extract-plugin
export default {"tableSize":"TableView_tableSize__+Ml71","table":"TableView_table__gUmLY","ranking":"TableView_ranking__5rIAi","name":"TableView_name__FQTjP","score":"TableView_score__KAd-L"};